import { PhoneCall, MessageCircle, ClipboardCheck, Headphones, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { claimsWhatsappUrl } from "@/constants/site";

const STEPS = [
  {
    icon: PhoneCall,
    title: "1. Contáctanos de inmediato",
    text: "Apenas ocurra el siniestro con tu maquinaria o equipo, llama o escríbenos por WhatsApp.",
  },
  {
    icon: ClipboardCheck,
    title: "2. Te guiamos con la denuncia",
    text: "Te ayudamos a reunir la documentación y a presentar el siniestro ante la aseguradora.",
  },
  {
    icon: Headphones,
    title: "3. Hacemos el seguimiento",
    text: "Acompañamos tu caso hasta que la aseguradora lo resuelva. No quedas solo en el proceso.",
  },
];

export const Claims = () => {
  return (
    <section id="siniestros" className="py-12 sm:py-16 bg-brand-ink text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand-yellow">
              Siniestros
            </p>
            <h2 className="font-display mt-3 text-3xl sm:text-5xl font-bold tracking-tight">
              ¿Tuviste un siniestro? Te acompañamos.
            </h2>
            <p className="mt-5 text-base sm:text-lg text-white/80">
              No te dejamos solo en el peor momento. Nuestro equipo te guía paso a paso
              en la denuncia y el seguimiento, hasta que tu caso quede resuelto.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row sm:flex-wrap gap-3">
              <Button
                asChild
                data-testid="claims-manage-btn"
                className="h-12 w-full sm:w-auto justify-center rounded-full bg-brand-yellow hover:bg-brand-yellowHover text-brand-ink font-semibold px-6 text-base transition-all hover:-translate-y-0.5 shadow-lg"
              >
                <Link to="/siniestro">
                  <FileText className="mr-1 h-5 w-5" /> Gestionar mi siniestro online
                </Link>
              </Button>
              <Button
                asChild
                data-testid="claims-whatsapp-btn"
                className="h-12 w-full sm:w-auto justify-center rounded-full bg-brand-whatsapp hover:bg-brand-whatsapp/90 text-white font-semibold px-6 text-base transition-all hover:-translate-y-0.5 shadow-lg"
              >
                <a href={claimsWhatsappUrl()} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="mr-1 h-5 w-5" /> Asistencia por WhatsApp
                </a>
              </Button>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-1 gap-4">
            {STEPS.map((s) => (
              <div
                key={s.title}
                data-testid={`claim-step-${s.title}`}
                className="flex gap-4 rounded-2xl border border-white/15 bg-white/5 backdrop-blur p-6"
              >
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-yellow/20 text-brand-yellow">
                  <s.icon className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-semibold">{s.title}</h3>
                  <p className="mt-1 text-sm text-white/75">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
